<div
  class="tab-pane fade show active projects-page"
  id="tab-home"
  role="tabpanel"
  aria-labelledby="home-tab"
>
  <div class="projects-tabs-strip">
    <div class="projects-tabs-inner">
      <ul
        ngbNav
        #nav="ngbNav"
        [(activeId)]="active"
        (activeIdChange)="onTabChanged($event)"
        [destroyOnHide]="false"
        class="nav-tabs"
      >
        <li [ngbNavItem]="1" [destroyOnHide]="true">
          <button ngbNavLink>
            {{ "projects.actualProjects" | translate }}
          </button>
          <ng-template ngbNavContent>
            <app-projects-with-filters
              [displayType]="'public'"
              [hideListCard]="true"
              [showProjectsListingHeader]="true"
              [projectsPageFilterSync]="syncProjectsPageFilters()"
            ></app-projects-with-filters>
          </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="true">
          <button ngbNavLink>
            {{ "projects.projectsInPreparation" | translate }}
          </button>
          <ng-template ngbNavContent>
            <app-projects-with-filters
              [displayType]="'underPreparation'"
              [hideListCard]="true"
              [showProjectsListingHeader]="true"
              [projectsPageFilterSync]="syncProjectsPageFilters()"
            ></app-projects-with-filters>
          </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="true">
          <button ngbNavLink>
            {{ "projects.closedProjects" | translate }}
          </button>
          <ng-template ngbNavContent>
            <app-projects-with-filters
              [displayType]="'closed'"
              [hideListCard]="true"
              [showProjectsListingHeader]="true"
              [projectsPageFilterSync]="syncProjectsPageFilters()"
            ></app-projects-with-filters>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
  <div class="content-container projects-content-container">
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
